import React from "react";

function SvgIcMapPoi024(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M12.5 6.998a1.498 1.498 0 011.355.857C14.21 8.566 20 20.998 20 20.998H4s6.977-12.91 7.18-13.212A1.499 1.499 0 0112.5 7zm8.5 5c.429 0 .814.18 1.087.469.023.019.175.216.22.297.954 1.382 5.693 8.234 5.693 8.234h-6.013l-.173-.844c-.281-.604-1.734-3.267-3.081-6.153a88.005 88.005 0 011.099-1.443c.276-.342.697-.56 1.168-.56z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi024;
